import {Injectable} from '@angular/core';
import {GenericService} from "../../core/commons/generic.service";
import {QueryOptions} from "../../core/commons/query.options";
import {AuthService} from "../../core/security/auth.service";
import {CategoriaDictamen} from "../domain/categoria-dictamen";

@Injectable()
export class CategoriaDictamenService extends GenericService<CategoriaDictamen> {

    private resourcePath: string = "/categoria-dictamen";

    constructor(public authService : AuthService) {
        super(authService);
    }

    protected valueToEntity(value: Object): CategoriaDictamen {
        return new CategoriaDictamen(value);
    }

    protected getResourcePath(): string {
        return this.resourcePath;
    }

    public getDefaultQueryOptions(): QueryOptions {
        return new QueryOptions();
    }
}



// WEBPACK FOOTER //
// ./src/app/fiscalia/service/categoria-dictamen.service.ts